var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrowImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221 56",
    width: 221,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .2;fill: #ffffff } \n\t\t.s1 { fill: none;stroke: #ffa26d;stroke-width: 1.6 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m184.5 56h-184.5l35.3-28-35.3-28h184.5l35.5 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m184.2 0.8l34.5 27.2-34.5 27.2h-181.9l33.5-26.6 0.8-0.6-0.8-0.6-33.5-26.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowImg);
export default __webpack_public_path__ + "static/media/white-arrow-img.88db3224dcfca148beb96589808998a0.svg";
export { ForwardRef as ReactComponent };